var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenericError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5129_22998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47,
    fill: "white",
    stroke: "url(#paint0_linear_5129_22998)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7428 26.3301L70.7571 57.542C72.5586 60.6488 70.3003 64.5519 66.7104 64.5519H30.6817C27.0788 64.5519 24.8335 60.6619 26.635 57.542L44.6494 26.3301C46.4508 23.2233 50.9544 23.2233 52.7428 26.3301Z",
    fill: "#F83B3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6756 57.7904C48.5451 57.7904 48.4276 57.7774 48.297 57.7513C48.1796 57.7252 48.049 57.686 47.9315 57.6338C47.814 57.5946 47.6966 57.5294 47.5921 57.451C47.4877 57.3727 47.3833 57.2944 47.2919 57.203C46.9264 56.8375 46.7045 56.3153 46.7045 55.7932C46.7045 55.271 46.9133 54.7489 47.2919 54.3834C47.3833 54.2789 47.4877 54.2006 47.5921 54.1353C47.6966 54.057 47.814 54.0048 47.9315 53.9526C48.049 53.8873 48.1796 53.8612 48.297 53.8351C48.9497 53.7046 49.6285 53.9134 50.0985 54.3834C50.464 54.7489 50.6859 55.258 50.6859 55.7932C50.6859 56.3284 50.477 56.8245 50.0985 57.203C49.7199 57.5685 49.1978 57.7904 48.6756 57.7904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6951 50.9239C47.7161 50.9239 46.9198 50.1275 46.9198 49.1484V37.3609C46.9198 36.3818 47.7161 35.5854 48.6951 35.5854C49.6742 35.5854 50.4705 36.3818 50.4705 37.3609V49.1484C50.4574 50.1405 49.6742 50.9239 48.6951 50.9239Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5129_22998",
    x1: 14.5001,
    y1: 14.5001,
    x2: 81.5,
    y2: 81.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16A83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5129_22998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericError);
export default __webpack_public_path__ + "static/media/generic_error.bfbb4120cc0c17d82b9441abdd90acd9.svg";
export { ForwardRef as ReactComponent };